import React from "react";
import { UserData } from "@/entities/users/types";
import { useReport } from "@/entities/reporting/hooks";
import { ReportType } from "@/entities/reporting/types";
import SalesVSQuota from "@/components/layouts/SalesVSQuota/SalesVSQuota";

interface Props {
  userData?: UserData;
  showWidget: boolean;
}

const SalesVSQuotaWrapper: React.FC<Props> = ({
  userData,
  showWidget = false
}) => {
  const { report, isLoading } = useReport(ReportType.SALES_VS_QUOTA);

  return showWidget ? (
    <SalesVSQuota data={report} userData={userData} isLoading={isLoading} />
  ) : null;
};

export default SalesVSQuotaWrapper;
